__turbopack_context__.v({
  "blok-big-title": "gallery-module__mQJwqa__blok-big-title",
  "blok-subtitle": "gallery-module__mQJwqa__blok-subtitle",
  "blok-title": "gallery-module__mQJwqa__blok-title",
  "product-card__image": "gallery-module__mQJwqa__product-card__image",
  "root": "gallery-module__mQJwqa__root",
  "second-image": "gallery-module__mQJwqa__second-image",
});
